<template>
  <pass-reset-fields
      :currUser = currUser
  />
  <br>
  <a id="back-opt" @click="$emit('back')">← {{ strings['Back'] }}</a>
  <input type="button" :value="strings['ResetPass']" id="reset-button"
         class="button button-primary button-large" @click="resetPass">
</template>

<script setup>
import $ from 'jquery';
import {onMounted, ref} from "vue";
import PassResetFields from "./passResetFields";
const emit = defineEmits(['notice']);
const props = defineProps(["strings", "otp"]);

let currUser = ref('');
let strings = props.strings;
let otp = props.otp;

onMounted(function() {
  currUser.value = $('#user_login').val();
});

function resetPass() {
  $(document.body).css({'cursor' : 'wait'});
  $('#reset-button').prop("disabled", true);

  $.post(strings['AjaxUrl'], {
    action: 'otp-reset-pass',
    usernameOrEmail: currUser.value,
    OTP: otp,
    newPass: $('#pass1').val()
  }, function(res) {
    let data = $.parseJSON(res);
    if (data.success) {
      emit('notice', strings['ResetSuccess'], 'message')
      $('#lostpasswordform').hide();
    } else {
      $('#pass1').attr('type', 'text');
      emit('notice', data.errorMessage, 'error')
    }

    $(document.body).css({'cursor' : 'default'});
    $('#reset-button').prop("disabled", false);
  });
}
</script>

<style scoped>
#back-opt {
  float: left;
  margin-top: 7px;
}
</style>